/**
 * Internally created training records (Employee Training Records →
 * "Internally Created" tab). All keys are prefixed `itr-` to keep them out
 * of the way of the other domains in the flat merged namespace.
 *
 * Assembled from the partials that live beside the feature so each ported
 * area owns its own strings.
 */
import base from '@/views/trainingReport/internal/i18n/base';
import dialogs from '@/views/trainingReport/internal/i18n/dialogs';
import internal from '@/views/trainingReport/internal/i18n/internal';
import print from '@/views/trainingReport/internal/i18n/print';

const LOCALES = ['en', 'es', 'fr', 'fr-ca'];
const partials = [base, dialogs, internal, print];

export default Object.fromEntries(
  LOCALES.map((locale) => [locale, Object.assign({}, ...partials.map((p) => p[locale] ?? {}))]),
);
